import { render, staticRenderFns } from "./AiWorkspaceComponent.vue?vue&type=template&id=7ff77928&scoped=true"
import script from "./AiWorkspaceComponent.vue?vue&type=script&lang=js"
export * from "./AiWorkspaceComponent.vue?vue&type=script&lang=js"
import style0 from "./AiWorkspaceComponent.vue?vue&type=style&index=0&id=7ff77928&prod&lang=css"
import style1 from "./AiWorkspaceComponent.vue?vue&type=style&index=1&id=7ff77928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff77928",
  null
  
)

export default component.exports